import React from 'react';
import styled from 'styled-components/macro';
import StoreFilter from './StoreFilter';
import StoreProducts from './StoreProducts';
import { StoreProps } from '../types/ProductsProps';

const UnstyledStore: React.FC<StoreProps> = ({
  className,
  pricing,
  enablevariations,
  defaultfilter,
  sort,
  cartaction,
  toasteroptions,
  likebutton,
  buybutton,
  trybutton,
  variationsort,
}) => {
  return (
    <div className={'ww-widget ww-store ' + className}>
      <div className="content">
        <StoreFilter defaultfilter={defaultfilter} sort={sort} />
        <StoreProducts
          variationsort={variationsort}
          cartaction={cartaction}
          toasteroptions={toasteroptions}
          pricing={pricing}
          enablevariations={enablevariations}
          defaultfilter={defaultfilter}
          sort={sort}
          likebutton={likebutton}
          buybutton={buybutton}
          trybutton={trybutton}
        />
      </div>
    </div>
  );
};

const Store = styled(UnstyledStore)`
  .content {
    display: flex;
    flex-direction: column;
  }

  .content .ww-store-filter {
    flex: auto;
  }

  .content .ww-store-products {
    flex: auto;
  }

  @media (min-width: 1200px) {
    .content {
      flex-direction: row;
      margin: auto;
      padding: 0 1em;
      width: calc(1200px - 2em);
    }
    .content .ww-store-filter {
      flex: 1 1;
      margin-right: 2em;
    }
    .content .ww-store-products {
      flex: 3 3;
    }
    .content .ww-store-products .ww-products {
      max-width: initial;
    }
    .content .ww-store-products .ww-products .list {
      justify-content: left;
    }
  }
`;

export default Store;
